import React, { useState, useEffect, useRef } from "react";
import "ag-grid-community/styles/ag-grid.css";
import "ag-grid-community/styles/ag-theme-quartz.css";
import { AgGridReact } from "ag-grid-react";
import moment from "moment/moment";
import "../pagination/pagination.css";
import Pagination from "../pagination/pagination";
import Select from "react-select";
import { RiRefreshLine } from "react-icons/ri";
import { FaFileCircleExclamation } from "react-icons/fa6";
import LeaseApiService from "../../services/apiService";
import jsPDF from "jspdf";
import "jspdf-autotable";
import { ClipLoader } from 'react-spinners';
import { toast } from "react-toastify";
import * as XLSX from "xlsx";
import { useTranslation } from 'react-i18next';
import "../customerMaster/customerListing.css";
import "./reports.css";
import { useReportCards } from "../shared/reportCards";

const TenantOccupancyReport = () => {
    const { t } = useTranslation(['reports', 'common']);
    const apiService = new LeaseApiService();
    const gridRef = useRef();
    const [rowData, setRowData] = useState([]);
    const [exportData, setExportData] = useState([]);
    const [loading, setLoading] = useState(false);
    const [pageSize, setPageSize] = useState(50);
    const [pagination, setPagination] = useState();
    const [FilterTab, setFilterTab] = useState(true);
    const [propertyList, setPropertyList] = useState([]);
    const [loader, setLoader] = useState(false);
    const [formData, setFormData] = useState({
        property: { label: "All", value: "All" },
    })
    useEffect(() => {
        fetchDropdownData();
    }, []);

    const fetchDropdownData = async () => {
        try {
            const params = new URLSearchParams();
            params.append('dropdownTypes', 'LRAgreeSearchProperties,');
            const res = await apiService.getApiParamater('REPORT_MULTI_DROP', `?${params.toString()}`);
            setPropertyList(res?.data?.dropdowns?.LRAgreeSearchProperties);
        } catch (error) {
            console.error('Error fetching dropdown data:', error);
        }
    }
    const getItems = async (newPageNo = pagination?.currentPage) => {
        try {
            setLoader(true)
            const params = new URLSearchParams();
            params.append("PageNo", newPageNo || 1);
            params.append("PageSize", pageSize || 50);
            params.append("PropertyNo", formData?.property?.value?.value || "All");
            const res = await apiService.getApiParamater("REPORT_TENANT_OCCUPANCY", `?${params.toString()}`);
            if (res?.data?.result) {
                setRowData(res?.data?.result || []);
                setPagination(res.data.paginationData);
                getAllItems(res.data.paginationData)
                setLoading(false);
                setLoader(false)
            } else {
                setRowData(res?.data?.result || []);
                toast.error(res?.data?.message)
                setLoader(false)
                setLoading(false);
            }
        } catch (error) {
            console.error("Error fetching items:", error);
            setLoader(false)
            setLoading(false);
        }
    }
    const getAllItems = async (total) => {
        try {
            setLoader(true)
            const params = new URLSearchParams();
            params.append("PageNo", 1);
            params.append("PageSize", total?.totalRecords);
            params.append("PropertyNo", formData?.property?.value?.value || "All");
            const res = await apiService.getApiParamater("REPORT_TENANT_OCCUPANCY", `?${params.toString()}`);
            if (res?.data?.result) {
                setExportData(res?.data?.result || []);
                setLoading(false);
                setLoader(false)
            } else {
                setLoader(false)
                setLoading(false);
            }
        } catch (error) {
            console.error("Error fetching items:", error);
            setLoading(false);
        }
    }
    const columnDefs = [
        { headerName: t('reports:tenantOccupancy.columns.propertyNo'), field: "property_No", filter: true, floatingFilter: true, suppressMovable: true, width: 130, pinned: "left" },
        { headerName: t('reports:tenantOccupancy.columns.propertyName'), field: "property_Name", filter: true, floatingFilter: true, suppressMovable: true, width: 200, pinned: "left" },
        { headerName: t('reports:tenantOccupancy.columns.totalLeasableArea'), field: "total_Leasable_Area", filter: true, floatingFilter: true, suppressMovable: true, width: 160 },
        { headerName: t('reports:tenantOccupancy.columns.totalLeasedArea'), field: "total_Leased_Area", filter: true, floatingFilter: true, suppressMovable: true, width: 160 },
        { headerName: t('reports:tenantOccupancy.columns.totalAvailableArea'), field: "total_Avalible_Area", filter: true, floatingFilter: true, suppressMovable: true, width: 160 },
        { headerName: t('reports:tenantOccupancy.columns.leasedPercentArea'), field: "leased_Percentage_Area", filter: true, floatingFilter: true, suppressMovable: true, width: 140 },
        { headerName: t('reports:tenantOccupancy.columns.vacantPercentArea'), field: "vacant_Percentage_Area", filter: true, floatingFilter: true, suppressMovable: true, width: 140 },
        { headerName: t('reports:tenantOccupancy.columns.totalLeasableUnits'), field: "total_leaseable_units", filter: true, floatingFilter: true, suppressMovable: true, width: 160 },
        { headerName: t('reports:tenantOccupancy.columns.leasedUnits'), field: "leased_units", filter: true, floatingFilter: true, suppressMovable: true, width: 130 },
        { headerName: t('reports:tenantOccupancy.columns.vacantUnits'), field: "vacant_units", filter: true, floatingFilter: true, suppressMovable: true, width: 130 },
        { headerName: t('reports:tenantOccupancy.columns.leasedPercent'), field: "leased_Percetnage", filter: true, floatingFilter: true, suppressMovable: true, width: 120 },
        { headerName: t('reports:tenantOccupancy.columns.vacantPercent'), field: "vacant_Percetnage", filter: true, floatingFilter: true, suppressMovable: true, width: 120 },
    ]
    const handleClearFilters = () => {
        setRowData([])
        setFormData({
            property: { label: "All", value: "All" },
        });
    }
    const handleDropDownChange = ({ name, value }) => {
        setFormData(prev => ({ ...prev, [name]: value }));
    }
    const normalizeValue = (value) => {
        if (value === null || value === undefined) return "";
        if (value === 0 || value === "0") return "";
        return value;
    };
    const exportColumns = [
        { header: "Property No", dataKey: "property_No" },
        { header: "Property Name", dataKey: "property_Name" },
        { header: "Total Leasable Area", dataKey: "total_Leasable_Area" },
        { header: "Total Leased Area", dataKey: "total_Leased_Area" },
        { header: "Total Available Area", dataKey: "total_Avalible_Area" },
        { header: "Leased % Area", dataKey: "leased_Percentage_Area" },
        { header: "Vacant % Area", dataKey: "vacant_Percentage_Area" },
        { header: "Total Leasable Units", dataKey: "total_leaseable_units" },
        { header: "Leased Units", dataKey: "leased_units" },
        { header: "Vacant Units", dataKey: "vacant_units" },
        { header: "Leased %", dataKey: "leased_Percetnage" },
        { header: "Vacant %", dataKey: "vacant_Percetnage" },
    ];
    const exportPDF = () => {
        if (!exportData?.length) return;

        const doc = new jsPDF("landscape", "pt", "A4");

        doc.setFillColor(110, 81, 153);
        doc.rect(0, 0, doc.internal.pageSize.width, 50, "F");

        doc.setTextColor(255);
        doc.setFontSize(16);
        doc.text("Occupancy Report", 40, 32);

        doc.setFontSize(9);
        doc.text(
            `Generated on: ${moment().format("DD-MMM-YYYY")}`,
            doc.internal.pageSize.width - 160,
            32
        );

        doc.setTextColor(0);

        doc.autoTable({
            startY: 60,
            head: [exportColumns.map(col => col.header)],
            body: exportData.map(row =>
                exportColumns.map(col => normalizeValue(row[col.dataKey]))
            ),
            styles: {
                fontSize: 8,
                cellPadding: 5,
                valign: "middle",
            },
            headStyles: {
                fillColor: [110, 81, 153],
                textColor: 255,
                fontStyle: "bold",
                halign: "center",
            },
            bodyStyles: {
                halign: "center",
            },
            alternateRowStyles: {
                fillColor: [240, 237, 245],
            },
            didDrawPage: data => {
                doc.setFontSize(8);
                doc.text(
                    `Page ${data.pageNumber}`,
                    doc.internal.pageSize.width / 2,
                    doc.internal.pageSize.height - 10,
                    { align: "center" }
                );
            },
        });
        doc.save("Occupancy Report.pdf");
    };
    const exportExcel = () => {
        if (!exportData?.length) return;

        const excelData = exportData.map(item => {
            const row = {};
            exportColumns.forEach(col => {
                row[col.header] = normalizeValue(item[col.dataKey]);
            });
            return row;
        });

        const worksheet = XLSX.utils.json_to_sheet(excelData);
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, "Occupancy Report");
        XLSX.writeFile(workbook, "Occupancy Report.xlsx");
    };
    const cards = useReportCards({
        label: "Properties in view",
        rowData,
        exportData: exportData,
        pagination,
        fields: [],
        extra: [
            { id: "full", label: "Fully leased", test: (r) => Number(r?.vacant_units) === 0 },
            { id: "vacancy", label: "With vacancies", test: (r) => Number(r?.vacant_units) > 0 },
        ],
    });

    return (
        <div className="cl-page rpt-legacy">
            <div className="cl-titlebar">
                <div className="cl-title">
                    <h1>{t('reports:tenantOccupancy.title')}</h1>
                    <p>{t('reports:tenantOccupancy.description', 'Which tenants occupy which units.')}</p>
                </div>
            </div>
            {cards.strip}
            <div className="cost-center-section">
                <div
                    className="d-flex mt-3 cursor-pointer slide-header"
                    onClick={() => setFilterTab(!FilterTab)}
                >
                    <div className="h6 pt-1">{t('common:searchParameters')}</div>
                </div>
                <div className={`slide-content ${FilterTab ? "open" : "closed"}`}>
                    <div className={`border-box2 p-3 ${FilterTab ? "slide-in" : "slide-out"}`}>
                        <div className="d-flex flex-wrap justify-content-between align-items-end" style={{ maxWidth: '1200px', margin: 'auto', gap: '20px' }}>
                            <div className="d-flex" style={{ minWidth: '340px' }}>
                                <label htmlFor="validationCustom18" className="form-label">{t('common:property')} </label>
                                <Select
                                    className="p-0 w-100"
                                    theme={(theme) => ({
                                        ...theme,
                                        borderRadius: 5,
                                        padding: 9,
                                    })}
                                    menuPortalTarget={document.body}
                                    isClearable
                                    styles={{
                                        menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                        option: (provided, state) => ({
                                            ...provided,
                                            backgroundColor: state.isFocused ? "#F5F5F5 " : null,
                                            color: state.isFocused ? "#000 " : "#000",
                                            ":hover": {
                                                backgroundColor: "#F5F5F5",
                                                color: "#000 ",
                                            },
                                        }),
                                    }}
                                    value={formData?.property}
                                    onChange={(selectedOption) => handleDropDownChange({ name: 'property', value: selectedOption })}
                                    options={propertyList?.map(country => ({ value: country, label: country?.text }))}
                                />
                            </div>
                            <div className="d-flex gap-1">
                                {loader === true ?
                                    <div className='mainbtnGry flex-end gap-2 w-50'>
                                        <ClipLoader color="#ffffff" className='mt-1' size={25} />
                                    </div>
                                    :
                                    <div
                                        onClick={() => getItems()}
                                        className="mainbtnGry flex-end gap-2 w-50"
                                    >
                                        <FaFileCircleExclamation
                                            color="#fff"
                                            className="center mt-2 mx-2"
                                        />
                                        <div className="center">{t('common:search')}</div>
                                    </div>
                                }
                                <div
                                    onClick={() => handleClearFilters()}
                                    className="mainbtnRed flex-end gap-2 w-50"
                                >
                                    <RiRefreshLine color="#fff" className="center mt-2 mx-2" />
                                    <div className="center">{t('common:reset')}</div>
                                </div>
                            </div>
                        </div>
                    </div>

                </div>
            </div>
            <div className="border-box2 p-3">
                {loading ? (
                    <div>{t('common:loading')}</div>
                ) : (
                    <>
                        <div className="d-flex justify-content-between">
                            <h5 className="col mainInvHead">{t('reports:tenantOccupancy.title')}</h5>
                            <button className="btn btn-primary" onClick={exportPDF}>
                                {t('reports:exportAsPdf')}
                            </button>
                            <button className="btn btn-secondary mx-3" onClick={exportExcel}>
                                {t('reports:exportAsExcel')}
                            </button>
                        </div>

                        <div className="gridshad mt-3">
                            <div className="ag-theme-quartz" style={{ height: 650 }}>
                                <AgGridReact
                                    ref={gridRef}
                                    rowData={cards.shownRows}
                                    enableFilter={true}
                                    floatingFilter={true}
                                    columnDefs={columnDefs}
                                />
                            </div>
                            {!cards.active && <Pagination
                                pageSize={pageSize}
                                setPageSize={setPageSize}
                                pagination={pagination}
                                getItems={getItems}
                            />}
                        </div>
                    </>
                )}
            </div>
        </div >
    );
};
export default TenantOccupancyReport;
